// extracted by mini-css-extract-plugin
export var caseStudyIntroduction = "case-study-module--case-study-introduction--26-m8";
export var caseStudyIntroductionImage = "case-study-module--case-study-introduction-image--1k3u0";
export var caseStudyCompanyProfile = "case-study-module--case-study-company-profile--23ql9";
export var caseStudyCompanyProfileImage = "case-study-module--case-study-company-profile-image--MfEsX";
export var caseStudyQuote = "case-study-module--case-study-quote--2t1vn";
export var caseStudyFact = "case-study-module--case-study-fact--cpUi8";
export var caseStudyResult = "case-study-module--case-study-result--1JXpy";